/* RidePolish — interacciones (vanilla, sin librerías) */
(function () {
  // Varias secciones incluyen este archivo: que solo se ejecute una vez por página
  if (window.__rpScriptsLoaded) return;
  window.__rpScriptsLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Devuelve true la primera vez para un elemento; evita enlazar eventos dos veces
  function once(el, key) {
    var k = 'rpBound' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  function initReveals() {
    var els = document.querySelectorAll('.rp-reveal:not(.rp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeroTilt() {
    document.querySelectorAll('[data-rp-tilt]').forEach(function (stage) {
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      if (!once(stage, 'Tilt')) return;
      var strength = parseFloat(stage.getAttribute('data-rp-tilt')) || 10;
      var tiles = stage.querySelectorAll('.rp-hero__tile');
      stage.addEventListener('mousemove', function (ev) {
        var r = stage.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        tiles.forEach(function (t, i) {
          var depth = (i + 1) * (strength / 10);
          var rot = t.getAttribute('data-rot') || 0;
          t.style.transform = 'translate3d(' + (x * 18 * depth) + 'px,' + (y * 14 * depth) + 'px,0) rotate(' + rot + 'deg)';
        });
      });
      stage.addEventListener('mouseleave', function () {
        tiles.forEach(function (t) { t.style.transform = ''; });
      });
    });
  }

  /* ---------- Carrito (usa el cajón de Dawn si existe) ---------- */
  function addToCart(items, onDone) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) { onDone(res.description || res.message || 'Something went wrong.'); return; }
        onDone(null);
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          try { drawer.renderContents(res); } catch (e) { window.location.href = '/cart'; }
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { onDone('Network error — please try again.'); });
  }

  function initKit() {
    document.querySelectorAll('[data-rp-kit]').forEach(function (box) {
      var btn = box.querySelector('[data-rp-kit-add]');
      var msg = box.querySelector('.rp-kit__msg');
      if (!btn || !once(box, 'Kit')) return;
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        btn.disabled = true;
        var label = btn.innerHTML;
        btn.textContent = btn.getAttribute('data-loading') || 'Adding…';
        addToCart(ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }), function (err) {
          btn.disabled = false;
          btn.innerHTML = label;
          if (msg) msg.textContent = err ? err : (btn.getAttribute('data-added') || 'Added to cart');
        });
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-rp-quick]').forEach(function (btn) {
      if (!once(btn, 'Quick')) return;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var id = btn.getAttribute('data-variant');
        if (!id) return;
        var label = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = '…';
        addToCart([{ id: parseInt(id, 10), quantity: 1 }], function (err) {
          btn.disabled = false;
          btn.innerHTML = label;
          if (err) alert(err);
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    document.querySelectorAll('[data-rp-product]').forEach(function (root) {
      if (!once(root, 'Product')) return;
      var dataEl = root.querySelector('[data-rp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('[data-rp-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = root.querySelector('[data-rp-price]');
      var compareEl = root.querySelector('[data-rp-compare]');
      var addBtn = root.querySelector('[data-rp-add]');
      var msg = root.querySelector('.rp-buy__msg');
      var mainImg = root.querySelector('[data-rp-main]');
      var thumbs = root.querySelectorAll('.rp-gallery__thumb');
      var qtyInput = root.querySelector('.rp-qty input');
      var sticky = document.querySelector('.rp-sticky-atc');
      var stickyPrice = sticky ? sticky.querySelector('.rp-sticky-atc__price') : null;
      var money = function (cents) {
        var fmt = root.getAttribute('data-money') || '${{amount}}';
        var v = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
      };

      function setMain(src, alt) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = '0';
        setTimeout(function () { mainImg.removeAttribute('srcset'); mainImg.src = src; if (alt) mainImg.alt = alt; mainImg.style.opacity = '1'; }, 150);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          setMain(t.getAttribute('data-src'), t.getAttribute('data-alt'));
        });
      });

      function currentOptions() {
        var opts = [];
        root.querySelectorAll('.rp-option').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
          var lbl = fs.querySelector('legend span');
          if (lbl && c) lbl.textContent = c.value;
        });
        return opts;
      }
      function updateAvailability(opts) {
        root.querySelectorAll('.rp-option').forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
            var l = fs.querySelector('label[for="' + inp.id + '"]');
            if (l) l.classList.toggle('is-unavailable', !ok);
          });
        });
      }
      function onChange() {
        var opts = currentOptions();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        updateAvailability(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.innerHTML = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
        }
        if (v.featured_image && v.featured_image.src) setMain(v.featured_image.src, v.featured_image.alt);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('.rp-option input').forEach(function (inp) { inp.addEventListener('change', onChange); });
      if (variants.length > 1) updateAvailability(currentOptions());

      root.querySelectorAll('.rp-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qtyInput.value, 10) || 1;
          n = b.getAttribute('data-step') === 'up' ? n + 1 : Math.max(1, n - 1);
          qtyInput.value = n;
        });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (!idInput || !idInput.value) return;
          var label = addBtn.innerHTML;
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-loading') || 'Adding…';
          if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
          addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }], function (err) {
            addBtn.disabled = false;
            addBtn.innerHTML = label;
            if (msg) {
              msg.textContent = err ? err : (addBtn.getAttribute('data-added') || 'Added to cart');
              msg.classList.toggle('is-error', !!err);
            }
          });
        });
      }

      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var so = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0); });
        });
        so.observe(addBtn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
      }
    });
  }

  function init() {
    initReveals();
    initHeroTilt();
    initKit();
    initQuickAdd();
    initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
